import { css } from '@emotion/core';
import { media, tokens } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
var colors = tokens.colors,
  borderRadius = tokens.borderRadius,
  spacing = tokens.spacing;
export var btrResetBox = /*#__PURE__*/css("padding:", spacing.l, ";border:1px solid ", colors.neutral.trim.default, ";background-color:", colors.neutral.surface.default, ";border-radius:", borderRadius.inner, ";max-width:1020px;margin-left:auto;margin-right:auto;display:flex;flex-direction:column;gap:", spacing.s, ";", media('>=tablet'), "{align-items:flex-start;}");
export var title = /*#__PURE__*/css(designTokenFonts.displaySmall, ";");
export var description = /*#__PURE__*/css(designTokenFonts.body, ";");